import {
  Checkbox,
  SvgIcon,
  type SvgIconProps,
  type CheckboxProps,
} from '@mui/material';
import CheckboxFull from '../../../assets/Checkbox-Full.svg?react';
import CheckboxEmpty from '../../../assets/Checkbox-Empty.svg?react';

export type MHMLogoCheckboxProps = CheckboxProps & {
  iconColor?: SvgIconProps['color'];
};

export function MHMLogoCheckbox({ iconColor, ...props }: MHMLogoCheckboxProps) {
  return (
    <Checkbox
      icon={
        <SvgIcon
          component={CheckboxEmpty}
          inheritViewBox
          color={iconColor ?? 'primary'}
          sx={{ fontSize: '30px' }}
        />
      }
      checkedIcon={
        <SvgIcon
          component={CheckboxFull}
          inheritViewBox
          color={iconColor ?? 'primary'}
          sx={{ fontSize: '30px' }}
        />
      }
      color="default"
      {...props}
    />
  );
}
